export default "__VITE_ASSET__D0dLvDvD__"